import {createContext, useContext} from 'react'

import {PartStatus, Run} from './types'

/** The part this tab has out, and when it sent it. */
export type InFlight = {index: number; sentAt: number}

export type RunDriver = {
  /** The run this tab sends parts for, or last sent them for. */
  run: Run | null
  driving: boolean
  inFlight: InFlight | null
  /** The parts the pass in progress still sends after the one in flight. */
  queued: Set<number> | null
  /** The notice the user has already seen or hidden, as `run id:phase`. */
  seen: string | null
  drive: (run: Run, resend?: PartStatus[]) => void
  pause: () => void
  checkUndecided: (run: Run) => void
  /** Keeps a newer view of the run this tab drives; any other run is ignored. */
  update: (run: Run) => void
  /** Lets go of a run that is not being driven. */
  forget: () => void
  markSeen: (key: string) => void
}

export const RunDriverContext = createContext<RunDriver | null>(null)

export const useRunDriver = () => {
  const driver = useContext(RunDriverContext)
  if (!driver) throw new Error('useRunDriver is used outside RunDriverProvider')
  return driver
}
